<template>
  <sp-button
    class="sp-table-page-step"
    :class="classModifiers"
    part="page-step"
    variant="outlined"
    color="text"
    size="x-small"
    :disabled="disabled"
    :accessible-name="accessibleName"
    :aria-current="ariaCurrent"
    @click="emit('activate')"
  >
    {{ label }}
  </sp-button>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * Accessible name, for a step whose visible text is a bare page number.
   */
  accessibleName: {
    type: String,
    default: undefined,
  },
  /**
   * This step is the page being shown.
   */
  current: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["activate"]);

const classModifiers = computed(() => ({ "--current": props.current }));
const ariaCurrent = computed(() => (props.current ? "page" : undefined));
</script>

<style lang="scss" scoped>
// The admin pager renders its steps as bordered boxes in the base text colour, teal only on hover.
.sp-table-page-step {
  --sp-comp-button-x-small-font-size: 1em;

  &.--current {
    --sp-comp-button-text-outlined-text-color: var(--sp-sys-color-primary);
    --sp-comp-button-outlined-border-color: var(--sp-sys-color-primary);
    --sp-comp-button-font-weight: var(--sp-ref-font-weight-semi-bold);
  }
}
</style>
